import { 
    SET_PURCHASE_ORDER_HISTORY
} from './FleetPurchaseOrderHistoryType'

const initialState = {
    fleetPurchaseOrderHistory: []
}

const reducer = (state = initialState, action: any) => {
    if (action.type === SET_PURCHASE_ORDER_HISTORY) {
        return {
            ...state,
            fleetPurchaseOrderHistory: action.fleetPurchaseOrderHistory
        }
    }
    else {
        return state;
    }
}

export default reducer;